import {REST} from '..'
import {GuidType} from '../values/generic-type-defintions'

export const VESSEL_TAGS_REST_URL = '/vessels/api/v1/locationTags'

export interface VesselTag {
    identity: GuidType
    name: string
}

export interface VesselTagResponse {
    tagIdentity: GuidType
    tagName: string
}

type CreateTagReqCommon = {
    locationIdentity?: string
}

export type AssignVesselToTagReq = CreateTagReqCommon & {
    locationTagIdentity: string
}

export type CreateVesselTagReq = CreateTagReqCommon & {
    tagDataDefinition: {name: string}
}

export type UpdateVesselTagReq = {
    identity: string
    name: string
}

export type UnassignVesselTagReq = {
    locationIdentity: GuidType
    locationTagIdentity: GuidType
}

export function getAllLocationTagsByLocation() {
    return REST.get<{[k: GuidType]: VesselTagResponse[]}>(
        `${VESSEL_TAGS_REST_URL}/allLocationTagsByLocation`,
    )
}

export function getAllVesselTags() {
    return REST.get<VesselTag[]>(VESSEL_TAGS_REST_URL)
}

export function createVesselTag(req: AssignVesselToTagReq | CreateVesselTagReq) {
    return REST.post<VesselTag>(VESSEL_TAGS_REST_URL, req)
}

export function updateVesselTag(req: UpdateVesselTagReq) {
    return REST.put<VesselTag>(VESSEL_TAGS_REST_URL, req)
}

export function unassignVesselTag(req: UnassignVesselTagReq) {
    return REST.post(`${VESSEL_TAGS_REST_URL}/unassignLocationTagFromLocation`, req)
}
